import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const FlutterFlags = () => {

    const servicesFaqData = [
        {
            question: "What customisation options are available for flutter flag printing?",
            answer: "Printingy offers a range of customisation options for Custom Flutter Flags Printing, including sizes, shapes, and full-colour designs. You can add logos, graphics, and promotional messages to ensure the flutter flags align with your branding goals."
        },
        {
            question: "Does Printingy handle bulk orders for flutter flags?",
            answer: "Yes, Printingy specialises in bulk Flutter Flags Printing, offering cost-effective solutions for large-scale events, trade shows, and outdoor promotions. Bulk orders ensure consistent quality and competitive pricing."
        },
        {
            question: "What materials are used for flutter flags?",
            answer: "We use durable, weather-resistant materials, such as high-quality polyester fabric, for printing flutter flags. These materials are lightweight, tear-resistant, and designed to withstand outdoor conditions, ensuring longevity and a professional appearance."
        },
        {
            question: "What industries benefit from flutter flag printing services?",
            answer: "Flutter flags are widely used in retail, hospitality, events, and real estate industries. Businesses rely on Flutter Flags Printing for outdoor branding, promotional events, and trade shows to attract attention and enhance visibility."
        },
        {
            question: "Does Printingy offer flutter package printing for large events?",
            answer: "Yes, our flutter package printing services cater to businesses and event organisers needing large volumes of flutter flags. We ensure consistency, precision, and timely delivery for bulk orders, making us the ideal partner for large-scale projects."
        },
        {
            question: "Can I include my company logo and colours on Flutter Flags?",
            answer: "Absolutely. Our Custom Flutter Flags Printing services allow you to incorporate your company logo, colours, and messaging. We use advanced printing technology to ensure vibrant and accurate reproduction of your designs."
        },
        {
            question: "What is the turnaround time for flutter flag printing?",
            answer: "Turnaround times for Flutter Flags Printing depend on the order size and complexity. Standard bulk orders are completed within a few business days. We provide clear timelines for larger or highly customised designs to meet your deadlines."
        },
        {
            question: "Are flutter flags suitable for outdoor use?",
            answer: "Our flutter flags are printed on weather-resistant materials designed to withstand outdoor conditions, including sun exposure, wind, and light rain. This ensures durability and long-lasting performance for all outdoor branding needs."
        },
        {
            question: "How do I place an order for flutter flag printing?",
            answer: "Placing an order is simple and efficient. Visit our website and select your preferences for Custom Flutter Flags Printing, including size, material, and design options. Upload your artwork, and our team will assist you through approval to delivery."
        },
        {
            question: "What makes bulk flutter flag printing cost-effective?",
            answer: "Bulk Printing of Flutter Flags reduces per-unit costs, making it an economical choice for large-scale events and promotions. By streamlining production, Printingy delivers high-quality results at competitive prices, ensuring excellent value for your investment."
        }
    ];
    
    
    const [pageTitle, setPageTitle] = useState('Printing of Flutter Flags');  // Dynamic title state

    useEffect(() => {
      document.title = pageTitle; // Set the document title dynamically
    }, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title="Custom Flutter Flags Printing Services for Events and Promotions"
  description="Professional printing of flutter flags for events and branding. Bulk flutter flag printing, custom flutter flag printing, and flutter package printing solutions."
  keywords="Printing of Flutter Flags,
Flutter Flags Printing,
Custom Flutter Flags Printing,
Flutter package printing
"
/>


      <header className="services-header text-center py-5 serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Flutter Flags</h1>
              <h2 className="text-muted">
              Custom flutter flag printing for impactful branding and promotions
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Flutter flags are a powerful and cost-effective tool for enhancing brand visibility at events, trade shows, and outdoor promotions. Printingy specialises in the Printing of Flutter Flags, offering durable, high-quality solutions that make your brand stand out.</p>
          <p>Our services include Flutter Flags Printing and Custom Flutter Flags Printing tailored to your needs. We ensure flutter flags with vibrant designs, weather-resistant materials, and sharp graphics for retail promotions, exhibitions, or outdoor advertising.</p>
          <p>With bulk printing capabilities and flutter package printing solutions, Printingy guarantees consistency, quality, and cost-effectiveness for large-scale requirements. Trust us to deliver flutter flags that draw attention and elevate your brand presence.</p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3  rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Flutter Flags Printing</h2>
                <h3 className="large-hed">High-quality, durable, and vibrant flutter flags for events</h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing of Flutter Flags with precision and clarity.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk Flutter Flags Printing for cost-effective large-scale orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional Custom Flutter Flags Printing tailored to your branding needs.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    High-quality materials resistant to weather, UV exposure, and wear.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Advanced printing technology for vibrant colours and sharp details.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Custom sizes and shapes to suit your event or advertising requirements.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for all bulk and custom orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted solutions for trade shows, outdoor events, and promotions.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/flutterflags.jpg" // Path relative to the public folder
                  alt="Printing of flutter flags for events"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Flutter Flags Delivered On Time</h2>
            <h3 className="small-hed">Focus on your promotions while we handle your flutter flag printing needs</h3>
            <p>At Printingy, we use advanced printing technology and premium materials to produce professional Custom Flutter Flag Printing. Whether you need flutter flags for outdoor branding or large-scale events, our Printing ensures sharp, eye-catching results.</p>
            <p>Our streamlined processes guarantee timely delivery, even for bulk orders. Partner with Printingy to create durable and impactful flutter flags that capture attention and enhance your brand visibility.</p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default FlutterFlags;
